import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styles from './fundingDetailsTable.module.css';
import { useNavigate } from 'react-router-dom';
import { businessList, useIsMobile } from '../../../../../../../recoil';
import { useRecoilValue } from 'recoil';
import { formatCurrencyWithSpace } from '../../../../../../../helpers';
import {
  appTermText
} from '../../../../../../../constants';

export const FundingDetailsTable = ({
  withdrawalDetails,
  onClick,
  businessId,
  applicationId
}) => {

  const businessListDetails = useRecoilValue(businessList);
  const isMobile = useRecoilValue(useIsMobile);

  const navigate = useNavigate();
  const handleChangeAmountClick = () => {
    onClick();
    navigate(`/accounts/${applicationId}`);
  };

  const businessName = useMemo(() => {
    const matchedBusiness = businessListDetails?.businesses?.find(
      (business) => business.businessId === businessId
    );
    return matchedBusiness?.businessName || '';
  }, [businessId, businessListDetails]);

  const getChangeLinkAndAmount = () => {

    return (
      <div className={styles.actionBar}>
        {isMobile
          ? <><span>
            {formatCurrencyWithSpace(withdrawalDetails.drawdownAmount)}
          </span>
          <button onClick={handleChangeAmountClick} className={styles.url}>
              Change amount
          </button>
          </>
          : <><button onClick={handleChangeAmountClick} className={styles.url}>
            Change amount
          </button>
          <span className={styles.textGap}>
            {formatCurrencyWithSpace(withdrawalDetails.drawdownAmount)}
          </span></>
        }

      </div>
    );

  };

  const data = useMemo(() => {

    if (withdrawalDetails) {

      return [
        ['Drawdown amount', getChangeLinkAndAmount()],
        ['Total advanced amount', formatCurrencyWithSpace(withdrawalDetails.loanAmount)],
        ['No of months', appTermText[withdrawalDetails.termLength]],
        ['Company name', businessName],
        ['Total repayment', formatCurrencyWithSpace(withdrawalDetails.totalRepaymentAmount)]
      ];
    }
    return null;
  }, [withdrawalDetails, businessListDetails]);

  return (
    <>
      <div className={styles.table}>
        {data && data?.map((row, i) => (
          <div key={i} className={styles.row}>
            {isMobile ? (
              <>
                <div className={styles.fundingDetailsTitle}>{row[0]}</div>
                <div className={styles.fundingDetailsValue}>{row[1]}</div>
              </>
            ) : (
              <>
                <div className={styles.col}>{row[0]}</div>
                <div className={styles.col}>{row[1]}</div>
              </>
            )}
          </div>
        ))}

      </div>
    </>
  );
};

FundingDetailsTable.propTypes = {
  withdrawalDetails: PropTypes.object,
  onClick: PropTypes.func,
  applicationId: PropTypes.string.isRequired,
  businessId: PropTypes.string.isRequired
};